<div
  class="flex flex-col bg-surface-100 z-10 relative h-full w-72 transition-all duration-300"
  [class.w-16!]="!isOpen()"
  [class.shadow-lg]="!isOpen()"
  [tourStep]="TourStepId.Sidebar"
>
  <div class="border-b border-gray-200 p-1 flex items-center justify-center">
    @if (isOpen()) {
      <div class="flex-1"></div>
      <p-button
        icon="pi pi-angle-double-right"
        (click)="toggle()"
        variant="text"
        styleClass="text-gray-900!"
      ></p-button>
    } @else {
      <p-button
        icon="pi pi-angle-double-left"
        (click)="toggle()"
        variant="text"
        styleClass="text-gray-900!"
      ></p-button>
    }
  </div>
  <ng-container *ngTemplateOutlet="navigationDrawer"></ng-container>
</div>
<div class="md:hidden">
  <p-drawer [(visible)]="isOpenMobile" position="right" appendTo="body">
    <div tourPopoverPosition="bottom" [tourStep]="TourStepId.Sidebar">
      <ng-container *ngTemplateOutlet="navigationDrawer"></ng-container>
    </div>
  </p-drawer>
</div>
<ng-template #navigationDrawer>
  <!-- nav items -->
  <div class="flex flex-col flex-1">
    @for (item of items(); track $index) {
      <div>
        <div
          class="flex justify-center hover:bg-white"
          [class.bg-white]="item.expanded"
        >
          @if (isOpen() || isOpenMobile()) {
            <a
              class="flex flex-1 items-center gap-2 py-2 px-3"
              [class.cursor-pointer]="item.data?.link || item.children"
              [class.pointer-events-none]="modalOpen()"
              [class.opacity-50]="modalOpen()"
              [routerLink]="item.data?.link"
              (click)="handleItemClick(item)"
            >
              <ng-icon
                name="{{ item.icon }}"
                class="text-primary! text-xl"
                aria-hidden="true"
                size="1.4rem"
              ></ng-icon>
              <span class="text-surface-700 line-clamp-1 overflow-x-clip">{{
                item.label
              }}</span>
              @if (item.data?.link && !isArray(item.data?.link)) {
                <i
                  class="pi pi-external-link text-surface-400"
                  style="font-size: 12px"
                  aria-hidden="true"
                ></i>
              }
              @if (item.children) {
                <i
                  class="fa-solid fa-chevron-down mr-auto inline-flex! items-center! transition-all text-primary!"
                  [class.rotate-180]="item.expanded"
                ></i>
              }
            </a>
          } @else {
            <div class="flex items-center py-2 px-3">
              <ng-icon
                name="{{ item.icon }}"
                class="text-primary! text-xl"
                aria-hidden="true"
                size="1.4rem"
              ></ng-icon>
            </div>
          }
        </div>

        @if (item.expanded) {
          <div [@slideDown]>
            @for (subitem of item.children; track $index) {
              <div class="hover:bg-white">
                @if (isArray(subitem.data?.link)) {
                  <a
                    class="flex items-center gap-2 py-2 px-3"
                    [class.pointer-events-none]="modalOpen()"
                    [class.opacity-50]="modalOpen()"
                    [routerLink]="subitem.data?.link"
                    (click)="handleSubItemClick()"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        subitemLabel;
                        context: {
                          $implicit: subitem,
                        }
                      "
                    ></ng-container>
                  </a>
                } @else {
                  <a
                    class="flex items-center gap-2 py-2 px-3"
                    [class.pointer-events-none]="modalOpen()"
                    [class.opacity-50]="modalOpen()"
                    [href]="subitem.data?.link"
                    target="_blank"
                    (click)="handleSubItemClick()"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        subitemLabel;
                        context: {
                          $implicit: subitem,
                        }
                      "
                    ></ng-container>
                  </a>
                }
                <ng-template #subitemLabel let-subitem>
                  <i
                    class="{{ subitem.icon }} text-primary"
                    aria-hidden="true"
                  ></i>
                  <span class="text-surface-700">{{ subitem.label }}</span>
                  @if (!isArray(subitem.data?.link)) {
                    <i
                      class="pi pi-external-link text-surface-400"
                      style="font-size: 12px"
                      aria-hidden="true"
                    ></i>
                  }
                </ng-template>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="mt-auto"></div>
    <p-divider class="my-1!" />

    <button
      class="flex items-center justify-center gap-2 py-2 px-3 cursor-pointer text-primary!"
      [tourStep]="TourStepId.PortalGuide"
      (click)="startTour()"
    >
      <ng-icon
        name="lucideHelpCircle"
        aria-hidden="true"
        size="1.4rem"
      ></ng-icon>
      @if (isOpen() || isOpenMobile()) {
        <span
          class="flex-1 text-surface-700 line-clamp-1 overflow-x-clip text-start"
          >راهنمای پورتال</span
        >
      }
    </button>

    <div class="flex flex-col" [tourStep]="TourStepId.SupportLogout">
      @if (isOpen() || isOpenMobile()) {
        <div
          class="flex items-center gap-2 py-2 px-3 cursor-pointer text-primary!"
          (click)="callSupportExpanded.set(!callSupportExpanded())"
        >
          <ng-icon
            name="lucidePhone"
            aria-hidden="true"
            size="1.4rem"
          ></ng-icon>
          <span class="text-surface-700 line-clamp-1 overflow-x-clip"
            >تماس با پشتیبانی
          </span>
        </div>

        @if (callSupportExpanded()) {
          <div [@slideDown] class="py-2 px-3">
            <a href="tel:+02191002372" class="text-blue-600">02191002372 </a>
          </div>
        }
      }

      <button
        class="flex items-center justify-center gap-2 py-2 px-3 cursor-pointer text-primary!"
        (click)="logout()"
      >
        <ng-icon name="lucideLogOut" aria-hidden="true" size="1.4rem"></ng-icon>
        @if (isOpen() || isOpenMobile()) {
          <span
            class="flex-1 text-surface-700 line-clamp-1 overflow-x-clip text-start"
            >خروج</span
          >
        }
      </button>
    </div>

    <div class="h-4"></div>
  </div>
</ng-template>
